{
  "FileUpload_DragAndDrop": "Sleep het bestand hierheen of klik om het bestand te selecteren",
  "FileUpload_DropFileHere": "Zet het bestand hier neer",
  "FileUpload_Accepted": "Bestand wordt geaccepteerd",
  "FileUpload_Rejected": "Bestand wordt afgewezen",
  "FileUpload_SelectedFile": "Geselecteerd bestand: {}",
  "FileUpload_Validation_OverMaxSize": "Bestandsgrootte overschrijdt de maximaal toegestane grootte van {}",
  "FileUpload_Validation_MaxDimensions": "De bestandsafmetingen overschrijden de maximaal toegestane afmetingen van {}x{}",
  "FileUpload_Validation_MinDimensions": "De bestandsafmetingen liggen onder de minimaal toegestane afmetingen van {}x{}",
  "FileUpload_Validation_NotTransparent": "Bestandsachtergrond is niet transparant",
  "NAME": "FileUploadLanguage"
}